import {
    SET_MODAL,
    SET_MODAL_RESET,
    SET_NAVIGATION,
    SET_FOOTER_OPEN,
    SET_SCROLL_TO_ELEMENT,
    SET_SCROLL_TO_ELEMENT_RESET
} from "../actions/app";
const initialState = {
    modal: null,
    mainDrawerOpen: false,
    accountDrawerOpen: false,
    sendDrawerOpen: false,
    megaMenuOpen: false,
    megaMenuProgressVariant: 'determinate',
    headerOpen: false,
    footerOpen: false,
    scrollToElement: null
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case SET_NAVIGATION:
            return {
                ...state,
                ...action.data
            };
        case SET_FOOTER_OPEN:
            return {
                ...state,
                footerOpen: action.data
            };
        case SET_MODAL:
            return {
                ...state,
                modal: action.data
            };
        case SET_MODAL_RESET:
            return {
                ...state,
                modal: initialState.modal
            };
        case SET_SCROLL_TO_ELEMENT:
            return {
                ...state,
                scrollToElement: action.data
            };
        case SET_SCROLL_TO_ELEMENT_RESET:
            return {
                ...state,
                scrollToElement: initialState.scrollToElement
            };
        default:
            return state;
    }
} 